import {
  SET_DOWNLOAD_REQUESTS_DATA,
  SET_DOWNLOAD_REQUESTS_LOADER,
  SET_DOWNLOAD_REQUESTS_FILTERS,
  SET_DOWNLOAD_REQUESTS_PAGINATION,
} from 'src/common/actions/constants';

const initialState = {
  data: {
    downloadRequests: [],
    isNextPresent: false,
  },
  loader: false,
  filters: {
    dateRange: null,
    dumpType: 'all',
  },
  pagination: {
    pageNumber: 1,
    resultPerPage: 10,
    isNextPresent: false,
  },
};

const downloadRequestsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_DOWNLOAD_REQUESTS_DATA:
      return {
        ...state,
        data: {
          downloadRequests: action.data?.downloadRequests || [],
          isNextPresent: action.data?.isNextPresent || false,
        },
      };
    case SET_DOWNLOAD_REQUESTS_LOADER:
      return {
        ...state,
        loader: action.data,
      };
    case SET_DOWNLOAD_REQUESTS_FILTERS:
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.data,
        },
      };
    case SET_DOWNLOAD_REQUESTS_PAGINATION:
      return {
        ...state,
        pagination: {
          ...state.pagination,
          ...action.data,
        },
      };
    default:
      return state;
  }
};

export default downloadRequestsReducer;
